import { FC } from 'react';
interface Props {}
export const Divider: FC<Props> = ({}) => <div className={'_divider'} data-sentry-component="Divider" data-sentry-source-file="Divider.tsx" />;